/*
 * File: index.tsx
 * Desc: 表单搜索补全组件
 * File Created: 2019-11-26 14:12:26
 * Author: szq
 * ------
 * Copyright 2019 - present, karakal
 */

import React, { Component } from 'react';
import { Form, AutoComplete } from 'antd';
import { FormBaseProps } from '../form-input';
import { FormProps } from 'antd/lib/form';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import debounce from 'lodash.debounce';
const { Option } = AutoComplete;

interface FormAutoCompleteProps extends FormBaseProps, Omit<FormProps, 'onChange'> {
    optionsApi?: Function
}

interface FormAutoCompleteState {
    dataSource: any[]
}

class FormAutoComplete extends Component<FormAutoCompleteProps, FormAutoCompleteState> {
    constructor(props: FormAutoCompleteProps) {
        super(props);
        this.state = {
            dataSource: [],
        };
    }

    _debounceChange = debounce(value => {
        const { optionsApi, field } = this.props;
        const { validateFields } = this.props.form as WrappedFormUtils;
        if (validateFields) {
            validateFields([field], (errors) => {
                if (!errors && optionsApi) {
                    optionsApi(value).then((res: any) => {
                        this.setState({ dataSource: res });
                    });
                }
            });
        }
    }, 500);

    handleSearch = (value: string):void => {
        if (value && value.trim().length !== 0) {
            this._debounceChange(value);
        } else {
            this.setState({ dataSource: [] });
        }
    };

    render() {
        const { getFieldDecorator } = this.props.form as WrappedFormUtils;
        const { initialValue, label, field, required, validator, labelCol, wrapperCol, disabled, placeholder, className, style } = this.props;
        const { dataSource } = this.state;
        const children = dataSource.map(v => (
            <Option key={v.id} value={v.id}>
                {v.name}
            </Option>
        ));
        return (
            <Form.Item
                {...{
                    label,
                    labelCol,
                    wrapperCol,
                }}
                className={className}
                style={style}
            >
                {getFieldDecorator(field, {
                    initialValue,
                    rules: [
                        { required, message: `请选择${label}` },
                        {
                            validator: (rule, value, callback) => (validator ? validator(rule, value, callback) : callback()),
                        },
                    ],
                })(
                    <AutoComplete
                        onSearch={this.handleSearch}
                        placeholder={placeholder ? placeholder : `请输入${label}`}
                        disabled={disabled}
                        {...({ labelInValue: true }) as any}
                    >
                        {children}
                    </AutoComplete>
                )}
            </Form.Item>
        );
    }
}

export default FormAutoComplete;